const labels = document.querySelectorAll<HTMLElement>(".se-multi-checkbox__label")

labels.forEach((label) => {
  const text = label.querySelector<HTMLElement>(":scope > span")

  if (!text) return

  const handle = () => {
    const textWidth = text.offsetWidth
    const labelWidth = label.offsetWidth

    if (labelWidth >= textWidth) return

    const end = textWidth - labelWidth + 16

    label.style.setProperty("--end", `-${end}px`)

  }

  const resizeObserver = new ResizeObserver(handle)
  resizeObserver.observe(label)

})
